const defaultOrganizationActions = [
	{
		"owner": "bravas",
		"service": "events",
		"scope": "*",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessManagement",
		"scope": "*",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "identity",
		"scope": "organization",
		"action": "partialUpdate"
	},
	{
		"owner": "bravas",
		"service": "identity",
		"scope": "person",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "identity",
		"scope": "shift",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "identity",
		"scope": "tag",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "identity",
		"scope": "unit",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "command",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "accessModule",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "accessPoint",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "automationButton",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "user",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "credential",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "vehicle",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "group",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "get*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "updateFromUnit"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "updateFromOrganization"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "updateSnEquipment"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "transfer"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "license",
		"action": "allocate"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "door",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "doorIp",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "garage",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "garageIp",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "gate",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "gateIp",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "localDoor",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "general",
		"action": "reception"
	},
	{
		"owner": "bravas",
		"service": "backup",
		"scope": "*",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "notifier",
		"scope": "*",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "reader",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "antiPassback",
		"action": "*"
	},
	{
		"owner": "bravas",
		"service": "accessControl",
		"scope": "interlock",
		"action": "*"
	},
];

module.exports = {
	defaultOrganizationActions
}